<template>
  <div class="container">
    <app-header title="我的收货地址"/>
    <div class="addressall" v-for="item in addressList">
      <!--<div class="address">{{item.name}}</div>-->
      <div class="addedit">
        <div class="phone">{{item.name}}{{item.tel}}</div>
        <!--<img src="@/assets/edit.png" width="24" height="24" @click="edit(item)"/>-->
      </div>
      <div class="address">{{item.address + item.detail}}</div>
      <div class="address" style="text-align: right">
        <span @click="cancel(item.id)" v-if="item.isDefault">取消默认</span>
        <span @click="submit(item.id)" v-else>设为默认</span>
        <span @click="onNavigateEdit(item.id)">修改</span>
        <span @click="deleteShopAddress(item.id)">删除</span>
      </div>
    </div>
    <van-tabbar class="active_tab">
      <div class="addAddress" @click="addAddr">添加新地址</div>
    </van-tabbar>

  </div>
</template>

<script>
import { queryShopAddressList,updateShopAddress, defaultAddress,deleteShopAddress } from '../../api/address/index.js'
export default {
  name: 'Index',
  data() {
    return {
      addressList: []
    }
  },
  created() {
    this._queryShopAddressList()
  },
  methods: {
    deleteShopAddress(id){
      deleteShopAddress({id: id}).then(res=>{
        if (res.success){
          this._queryShopAddressList()
        }
      })
    },
    cancel(id){
      updateShopAddress({id: id,isDefault: false}).then(res=>{
        if (res.success){
          this._queryShopAddressList()
        }
      })
    },
    submit (id) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      defaultAddress({ id: id, uid: userInfo.id, isDefault: true }).then(res => {
        if (res.success) {
          this._queryShopAddressList()
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    onNavigateEdit(id){
      this.$router.push({
        path: '/address/edit',
        query: {
          id: id
        }
      })
    },
    edit(item) {
      this.$router.push('/edit?id=' + item.id)
    },
    addAddr() {
      this.$router.push('/addAddr')
    },
    _queryShopAddressList() {
      var user = localStorage.getItem("userInfo")
      user = JSON.parse(user)
      const params = {
        uid: user.id
      }
      queryShopAddressList(params).then((res) => {
        console.log(res,'这是地址列表')
        if (res.success) {
          this.addressList = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    padding-bottom: 60px;
    .addressall{
      width:95%;
      /*height:152px;*/
      background:rgba(255,255,255,1);
      box-shadow:0px 1px 2px rgba(0,0,0,0.16);
      opacity:1;
      margin-left: 2%;
      margin-top: 25px;

      .address{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
        padding: 8px;
      }
      .addedit{
        display: flex;
        justify-content: space-between;
        padding: 8px;
      }
    }
    .addAddress{
      width:95%;
      height:40px;
      background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
      opacity:1;
      border-radius:4px;
      text-align: center;
      line-height: 40px;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(255,255,255,1);
      margin-left: 2%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/address/index.vue